// // ClientSection.jsx
// import React, { useEffect, useRef, useState } from "react";
// import "../css-coding/ClientSection.css";
// import footerImage from "../assets/Profile.jpg";
// import avatar1 from "../assets/avatar1.png";
// import avatar2 from "../assets/avatar2.jpg";
// import avatar3 from "../assets/avatar3.png";
// import avatar4 from "../assets/avatar4.png";
// import avatar5 from "../assets/avatar5.png";
// import avatar6 from "../assets/avatar6.png";
// import avatar7 from "../assets/avatar7.jpg";
// import avatar8 from "../assets/avatar8.png";
// import avatar9 from "../assets/avatar9.png";
// import avatar10 from "../assets/avatar10.png";
// import avatar11 from "../assets/avatar11.png";

// const allAvatars = [
//   avatar1, avatar2, avatar3, avatar4, avatar5, avatar6,
//   avatar7, avatar8, avatar9, avatar10, avatar11
// ];

// const ClientSection = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [startIndex, setStartIndex] = useState(0);
//   const intervalRef = useRef(null);

//   // Device detection: mark some tablets (iPad Mini, Surface Duo) as "mobile"
//   const detectTabletAsMobile = () => {
//     if (typeof navigator === "undefined" || typeof window === "undefined") return false;

//     const ua = navigator.userAgent || navigator.vendor || window.opera;

//     // Surface Duo explicit match
//     if (/Surface Duo/i.test(ua)) return true;

//     // Standard iPad UA
//     if (/iPad/.test(ua)) return true;

//     // iPadOS 13+ sometimes reports as Mac — detect via touch support & screen dimensions
//     const hasTouch = 'ontouchstart' in window || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
//     const maxScreen = Math.max(window.screen.width || 0, window.screen.height || 0);

//     // <= 1100px max screen width will capture smaller tablets like iPad mini in landscape
//     if (hasTouch && maxScreen > 700 && maxScreen <= 1100) {
//       return true;
//     }

//     // Fallback: don't force mobile
//     return false;
//   };

//   // Resize handler: sets isMobile based on breakpoint OR forced-tablet detection
//   useEffect(() => {
//     const handleResize = () => {
//       const tabletForcedMobile = detectTabletAsMobile();
//       setIsMobile(tabletForcedMobile || window.innerWidth <= 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     // Some browsers change UA when switching orientation; also run on orientationchange
//     window.addEventListener("orientationchange", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       window.removeEventListener("orientationchange", handleResize);
//     };
//     // empty deps so it runs once on mount and cleans up on unmount
//   }, []);

//   // Mobile swirl animation: rotate visible avatars when isMobile is true
//   useEffect(() => {
//     // clear existing interval if any
//     if (intervalRef.current) {
//       clearInterval(intervalRef.current);
//       intervalRef.current = null;
//     }

//     if (isMobile) {
//       intervalRef.current = setInterval(() => {
//         setStartIndex((prev) => (prev + 1) % allAvatars.length);
//       }, 1500);
//     }

//     return () => {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//         intervalRef.current = null;
//       }
//     };
//   }, [isMobile]);

//   // Determine how many avatars to show: mobile -> max 5, desktop -> show all
//   const visibleCount = isMobile ? 5 : allAvatars.length;
//   const avatars = [];
//   for (let i = 0; i < visibleCount; i++) {
//     avatars.push(allAvatars[(startIndex + i) % allAvatars.length]);
//   }

//   // Radius adjustments
//   const radius = isMobile ? 120 : 500;
//   const centerY = 0; // top of section for semicircle

//   return (
//     <div className="client-sectionM">
//       <div className="arc-wrapper">
//         {avatars.map((img, index) => {
//           // Angle mapping:
//           // For mobile: map from -90° -> 90° across visibleCount items (so it looks like small arc)
//           // For desktop: map 0..(avatars.length-1) across 180° to make a semicircle
//           const angle = isMobile
//             ? -90 + (180 / Math.max(1, (visibleCount - 1))) * index
//             : (180 / Math.max(1, (avatars.length - 1))) * index;

//           const radians = (angle * Math.PI) / 180;
//           const x = radius * Math.cos(radians);
//           const y = -radius * Math.sin(radians); // invert for top being highest

//           return (
//             <div
//               key={index}
//               className="avatar"
//               style={{
//                 backgroundImage: `url(${img})`,
//                 left: `calc(50% + ${x}px)`,
//                 top: `${centerY + y + radius}px`, // move down to center inside wrapper
//                 transition: "left 1s ease, top 1s ease, transform 0.3s ease"
//               }}
//             />
//           );
//         })}

//         <div className="center-content">
//           <h2>
//             <b>
//               100+ clients get better <br className="mobile-break" />
//               videos, faster, because when
//             </b>
//             <br />
//             <span className="italic">quality</span> <b>matters, they trust <br /> The Growth Secret!</b>
//           </h2>

//           <a
//             href="https://cal.com/itsprakashhere/30min"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="intro-call"
//           >
//               <div className="cta-cc-button">
//             <img src={footerImage} alt="Agent" />
           
//             <div className="button-text-wrapper">
//               <div className="default-text">
//                 <strong>Book a 15-min intro call</strong>
//                 <br></br>
//                 <div className="online"> <span className="dot-gs">🟢︎</span>
//                  Available now</div>
//               </div>
//               <div className="hover-text">
//                 <strong>Open Calendar</strong>
//               </div>
//             </div>
//             </div>
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ClientSection;






import React, { useEffect, useState, useRef } from "react";
import "../css-coding/ClientSection.css";

import footerImage from "../assets/Profile.jpg";
import avatar1 from "../assets/avatar1.png";
import avatar2 from "../assets/avatar2.jpg";
import avatar3 from "../assets/avatar3.png";
import avatar4 from "../assets/avatar4.png";
import avatar5 from "../assets/avatar5.png";
import avatar6 from "../assets/avatar6.png";
import avatar7 from "../assets/avatar7.jpg";
import avatar8 from "../assets/avatar8.png";
import avatar9 from "../assets/avatar9.png";
import avatar10 from "../assets/avatar10.png";
import avatar11 from "../assets/avatar11.png";

const allaAvatars = [
  avatar1, avatar2, avatar11, avatar4, avatar5,
  avatar6, avatar3, avatar8, avatar9, avatar10,
  avatar3, avatar8, avatar9, avatar7, avatar4,
  avatar5, avatar10,
];

const ClientSectionM = () => {
  const [rotation, setRotation] = useState(0);
  const targetRotation = useRef(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [wrapperWidth, setWrapperWidth] = useState(
    window.innerWidth <= 1024 ? 700 : 1000
  );

  useEffect(() => {
    const updateSize = () => {
      setWrapperWidth(window.innerWidth <= 1024 ? 700 : 1000);
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      let animationFrameId;
      const rotationSpeed = 0.3;

      const autoRotate = () => {
        setRotation(prev => prev + rotationSpeed);
        animationFrameId = requestAnimationFrame(autoRotate);
      };

      animationFrameId = requestAnimationFrame(autoRotate);
      return () => cancelAnimationFrame(animationFrameId);
    } else {
      let lastScrollY = window.scrollY;
      let rafId = null;

      const handleScroll = () => {
        const delta = window.scrollY - lastScrollY;
        lastScrollY = window.scrollY;
        targetRotation.current += delta * 0.1;

        if (!rafId) startAnimation();
      };

      const startAnimation = () => {
        const animate = () => {
          setRotation(prev => {
            const diff = targetRotation.current - prev;
            if (Math.abs(diff) < 0.01) {
              rafId = null;
              return targetRotation.current;
            }
            return prev + diff * 0.012;
          });
          rafId = requestAnimationFrame(animate);
        };
        rafId = requestAnimationFrame(animate);
      };

      window.addEventListener("scroll", handleScroll, { passive: true });

      return () => {
        window.removeEventListener("scroll", handleScroll);
        if (rafId) cancelAnimationFrame(rafId);
      };
    }
  }, [isMobile]);

  const radius = wrapperWidth / 2 - 60;
  const angleStep = 360 / allaAvatars.length;

  return (
    <>
      <div className="gs-section-mcs">
        <div
          className="gs-arc-wrapper-mcs"
          style={{
            width: `${wrapperWidth}px`,
            height: `${wrapperWidth / 1.95}px`,
          }}
        >
          {allaAvatars.map((img, i) => {
            const baseAngle = angleStep * i + rotation;
            const theta = (baseAngle * Math.PI) / 180;

            const x = radius * Math.cos(theta);
            const y = -radius * Math.sin(theta);

            return (
              <div
                key={i}
                className="gs-avatar-mcs"
                style={{
                  backgroundImage: `url(${img})`,
                  left: `calc(50% + ${x}px)`,
                  top: `calc(100% + ${y}px)`,
                }}
              />
            );
          })}
        </div>

        <div className="gs-center-content-mcs">
          <h2>
            <b>
              100+ clients get better videos, faster, because when
            </b>{" "}
            <span className="italic-mcs">quality</span>{" "}
            <b>
              matters, they trust <br /> The Growth Secret!
            </b>
          </h2>

          <a
            href="https://cal.com/itsprakashhere/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="intro-call-gs-mcs"
          >
            <div className="cta-cc-button-gs-mcs">
              <img src={footerImage} alt="Agent" />

              <div className="button-text-wrapper-gs-mcs">
                <div className="default-text-gs-mcs">
                  <strong>Book a 15-min intro call</strong>
                  <br className="mobile-break-gs-mcs" />
                  <div className="online-gs-mcs">
                    <span className="dot-gs-mcs">🟢︎</span>
                    Available now
                  </div>
                </div>

                <div className="hover-text-gs-mcs">
                  <strong>Open Calendar</strong>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default ClientSectionM;

